/**
 * Base spacing unit
 * All spacing values are multiples of this base unit
 */

export const spacingBase = 4; // 4px base unit

export type SpacingBase = typeof spacingBase;
